import { useEffect, useState } from "react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Custom color picker: swatch grid + hex input. Never opens the native OS color
// dialog or eyedropper, which freeze the browser in Edge/Chromium.
const PALETTE = [
  "#0044FF", "#2563EB", "#0EA5E9", "#06B6D4", "#14B8A6", "#10B981",
  "#22C55E", "#84CC16", "#EAB308", "#F59E0B", "#F97316", "#EF4444",
  "#DC2626", "#EC4899", "#D946EF", "#A855F7", "#8B5CF6", "#6366F1",
  "#64748B", "#475569", "#334155", "#0F172A", "#78716C", "#7C2D12",
  "#831843", "#14532D", "#0C4A6E", "#A16207", "#FFFFFF", "#E2E8F0",
];

export default function SwatchPicker({ value, onChange, title, testid }) {
  const [open, setOpen] = useState(false);
  const [hex, setHex] = useState(value || "");

  useEffect(() => { setHex(value || ""); }, [value]);

  const applyHex = () => {
    let v = hex.trim();
    if (!v) return;
    if (!v.startsWith("#")) v = `#${v}`;
    if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(v)) {
      onChange(v);
      setOpen(false);
    }
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          type="button"
          title={title}
          className="h-7 w-10 rounded border border-border cursor-pointer shrink-0 hover:ring-2 hover:ring-primary/40 transition-shadow"
          style={{ background: value || "#e2e8f0" }}
          data-testid={testid}
        />
      </PopoverTrigger>
      <PopoverContent className="w-[196px] p-2" align="end" data-testid={`${testid}-panel`}>
        <div className="grid grid-cols-6 gap-1 mb-2">
          {PALETTE.map((c) => (
            <button
              key={c}
              type="button"
              onClick={() => { onChange(c); setOpen(false); }}
              className={`h-6 w-6 rounded border ${String(value).toLowerCase() === c.toLowerCase() ? "ring-2 ring-primary ring-offset-1" : "border-border/60"}`}
              style={{ background: c }}
              title={c}
              data-testid={`${testid}-swatch-${c.replace("#", "")}`}
            />
          ))}
        </div>
        <div className="flex items-center gap-1.5">
          <input
            value={hex}
            onChange={(e) => setHex(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && applyHex()}
            placeholder="#0044FF"
            className="h-7 flex-1 min-w-0 rounded border border-border bg-background px-2 text-xs font-mono"
            data-testid={`${testid}-hex`}
          />
          <button type="button" onClick={applyHex} className="h-7 px-2 rounded bg-primary text-primary-foreground text-xs font-semibold" data-testid={`${testid}-apply`}>Set</button>
        </div>
      </PopoverContent>
    </Popover>
  );
}
